import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47.82,27.01C46.3,39,36.1,48,24.01,48c-1.75,0-3.5-0.19-5.21-0.58l-9.67-7.73l0,0l-0.77-0.62l2.7-4l0.44-0.66
	l0,0l1-1.46l0.11-0.16l2.92-4.29l0.68-1l0,0l0,0l0.08-0.11l0.34-0.5l0.45-0.66l0.78-1.15l0.2-0.3l1-1.41l0.46-0.68l0.6-0.88
	L20.68,21l0.53-0.78l0.89-1.3l0,0l0.06-0.08l0,0l6.14-9l0.15,0.14L47.82,27.01z"
  />
);

const JawsAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_0}
    renderShadow={renderShadow}
  >
    <>
      <circle style={{ fill: '#333333' }} cx="33.65" cy="17.98" r="1.62" />
      <circle style={{ fill: '#333333' }} cx="13.34" cy="17.98" r="1.62" />
      <path
        style={{ fill: '#CCCCCC' }}
        d="M34.42,35.84H23.79H12.53c0,0-0.35-15.11,0.81-18.09c1.33-3.39,7.17-10.34,10.45-10.34s8.7,6.41,10,9.92
	C34.85,20.18,34.42,35.84,34.42,35.84z"
      />
      <path
        style={{ fill: '#333333' }}
        d="M15.88,35.83c0,0-1.55-17,7.54-17s7.72,17.06,7.72,17.06L15.88,35.83z"
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="20.65,19.38 22.28,22.04 22.28,18.8 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="19.1,20.06 20.65,22.86 20.65,18.8 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="18.79,20.83 19.84,23.67 17.41,22.86 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="17.41,22.86 18.22,25.29 16.59,24.48 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="16.59,25.29 17.41,26.92 15.78,26.92 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="15.78,26.92 17.41,28.54 14.97,28.54 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="22.28,18.8 23.09,22.04 24.71,18.8 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="24.71,18.8 24.71,22.04 27.15,18.8 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="26.85,19.61 26.34,22.86 28.78,20.42 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="17.94,30.56 18.22,28.54 19.1,29.3 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="28.51,21.23 27.15,23.67 29.59,22.86 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="29.59,22.86 28.78,25.29 30.4,24.48 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="30.4,25.01 29.59,26.92 31.21,26.92 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="30.69,27.32 29.59,28.54 31.21,28.54 "
      />
      <path
        style={{ fill: '#6699CC' }}
        d="M34.42,35.84h-3.28c0.05-0.6,1.21-17-7.72-17s-7.54,17-7.54,17h-3.35c0,0-0.35-15.11,0.81-18.09
	c1.33-3.39,7.18-10.34,10.45-10.34s8.71,6.41,10,9.92C34.84,20.18,34.42,35.84,34.42,35.84z"
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="19.1,29.3 19.03,26.92 20.65,28.54 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="20.32,27.93 20.65,25.29 22.28,26.92 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="21.75,26.1 22.28,24.48 23.09,26.1 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="23.09,26.1 23.9,23.67 24.71,26.1 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="24.71,26.1 25.53,24.48 26.34,27.73 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="25.93,27.32 27.15,25.29 27.15,28.54 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="27.96,30.16 28.78,28.54 29.11,30.56 "
      />
      <polygon
        style={{ fill: '#FFFFFF' }}
        points="26.34,29.34 27.96,26.92 28.27,29.55 "
      />
      <path
        style={{ fill: '#6699CC' }}
        d="M15.86,35.84c-0.75-0.68,4-10.56,8-10.56c3.65,0,7.65,10.2,7.3,10.56H15.86z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M14.55,36.23c0,0-1.89-4.71-4.71-5.65c-2.82-0.94-4.07-0.35-4.72,0.94c-0.94,1.88,0,2.83,0,2.83
	s1.89,1.88,3.77,0.94S14.55,36.23,14.55,36.23z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M10.93,29.44c0,0,0.08-2-0.84-2.82s-1.49-0.89-2-0.56c-0.68,0.46-0.48,1-0.48,1s0.4,1,1.28,1
	S10.93,29.44,10.93,29.44z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M35.46,28.6c0,0-0.11-2,0.79-2.84c0.9-0.84,1.47-0.92,1.94-0.61c0.69,0.46,0.5,1,0.5,1s-0.38,1-1.26,1.06
	C36.55,27.27,35.46,28.6,35.46,28.6z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M37.69,28.62c0.24-0.56,0.68-1.02,1.23-1.3c0.77-0.3,1.2-0.26,1.43,0c0.23,0.26,0.09,0.54,0.09,0.54
	c-0.31,0.26-0.7,0.39-1.1,0.36C38.76,28.22,38.2,28.36,37.69,28.62z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M32.01,36.23c0,0,1.88-4.71,4.71-5.65c2.83-0.94,4.06-0.35,4.71,0.94c0.94,1.88,0,2.83,0,2.83
	s-1.88,1.88-3.77,0.94S32.01,36.23,32.01,36.23z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M31.32,35.78c0,0,3.78-2,6-1.06s2.66,2,2.33,3.12c-0.49,1.69-1.58,1.79-1.58,1.79s-2.2,0.18-2.82-1.42
	S31.32,35.78,31.32,35.78z"
      />
      <path
        style={{ fill: '#B3E7F4' }}
        d="M17.08,35.8c0,0-3.79-2.11-6.3-1.18s-3.09,2-2.88,3.24c0.3,1.78,1.46,1.89,1.46,1.89s2.33,0.22,3.19-1.46
	C13.41,36.61,17.08,35.8,17.08,35.8z"
      />
      <ellipse
        style={{ fill: '#B3E7F4' }}
        cx="17.37"
        cy="37.17"
        rx="3.77"
        ry="2.83"
      />
      <ellipse
        style={{ fill: '#B3E7F4' }}
        cx="30.56"
        cy="37.17"
        rx="3.77"
        ry="2.83"
      />
      <ellipse
        style={{ fill: '#B3E7F4' }}
        cx="23.5"
        cy="36.23"
        rx="4.24"
        ry="2.83"
      />
    </>
  </AvatarArtwork>
);

export default JawsAvatarArtwork;
